"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultModalState = void 0;

var _immutable = require("immutable");

/**
 * @namespace skybase-components.sb-modal.sb-modal-utils
 */

/**
 * @description
 * gets default modal state
 * @return {immutablejs.Map} [description]
 */
var getDefaultModalState = function getDefaultModalState() {
  return new _immutable.Map({});
};

exports.getDefaultModalState = getDefaultModalState;
//# sourceMappingURL=sb-modal-utils.js.map